/**
 * Записи «Подсказок и новостей» по требованию — отдельным чанком, мимо основного веб-бандла.
 *
 * <p>Своим модулем, а не `import()` прямо в хуке: Jest без `--experimental-vm-modules`
 * динамический импорт не исполняет, а так тест подменяет одну функцию.
 */
export function loadHelpEntries(): Promise<typeof import('./helpEntries')> {
  return import('./helpEntries');
}
